import React, { ReactElement } from 'react'

import LogoLink from '@components/Logo/Link'
import PoweredByDistribusion from '@components/Logo/PoweredByDistribusion'
import config from '@config'
import useIsMobile from '@hooks/useIsMobile'
import { useTranslation } from '@lib/i18n'
import { useParams } from '@stores/params'

import '@components/Logo/index.scss'

interface LogoProps {
  showDistribusionBranding?: boolean
  url: string
  clickable?: boolean
}

const Logo = ({ showDistribusionBranding, url, clickable = true }: LogoProps): ReactElement | null => {
  const { t } = useTranslation()
  const [{ retailerPartnerNumber }] = useParams()
  const isMobile = useIsMobile()

  const logoContent = (
    <>
      <img
        src={url}
        className="logo-image"
        style={{ maxHeight: config.customGEBUI.byRPN.includes(retailerPartnerNumber) && isMobile ? '30px' : '50px' }}
        alt={t('accessibility.images.homePageLink')}
        data-tag="logo"
      />
      {showDistribusionBranding && <PoweredByDistribusion />}
    </>
  )
  return <div className="partner-logo">{clickable ? <LogoLink>{logoContent}</LogoLink> : logoContent}</div>
}

export default Logo
